/**
 * Nav catalog is not in the first HTML.
 * Desktop mega: fetch on hover. Mobile / drawer: fetch on first open.
 * Theme editor still inlines panels (design_mode).
 */
(function () {
  var cache = {};
  var inflight = {};
  var warmed = false;
  var desktopMega = window.matchMedia('(min-width: 1024px)');

  function fetchHtml(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    if (inflight[url]) return inflight[url];
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, 10000);
    inflight[url] = fetch(url, {
      credentials: 'same-origin',
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('amc-nav ' + res.status);
        return res.text();
      })
      .then(function (html) {
        cache[url] = html;
        return html;
      })
      .finally(function () {
        clearTimeout(timer);
        delete inflight[url];
      });
    return inflight[url];
  }

  function parseSelector(html, selector) {
    var slice = html;
    var open = html.indexOf('<body');
    if (open !== -1) {
      open = html.indexOf('>', open);
      var close = html.lastIndexOf('</body>');
      slice =
        '<div>' +
        html.slice(open + 1, close === -1 ? html.length : close) +
        '</div>';
    }
    var doc = new DOMParser().parseFromString(slice, 'text/html');
    var node = doc.querySelector(selector);
    if (!node) {
      doc.querySelectorAll('template').forEach(function (tpl) {
        if (!node && tpl.content) node = tpl.content.querySelector(selector);
      });
    }
    return node;
  }

  function adopt(from, to) {
    var html = from.innerHTML;
    if (window.Alpine && typeof Alpine.mutateDom === 'function') {
      Alpine.mutateDom(function () {
        to.innerHTML = html;
      });
    } else {
      to.innerHTML = html;
    }
  }

  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var next = document.createElement('script');
      if (old.src) next.src = old.src;
      else next.textContent = old.textContent;
      if (old.defer) next.defer = true;
      old.parentNode.replaceChild(next, old);
    });
  }

  function alpineInit(root) {
    if (!window.Alpine || typeof Alpine.initTree !== 'function') return;
    if (typeof Alpine.destroyTree === 'function') {
      try {
        Alpine.destroyTree(root);
      } catch (e) {}
    }
    Alpine.initTree(root);
  }

  function firstOpenScope(root) {
    return (
      root.querySelector('[data-amc-mega-first]') ||
      root.querySelector('.toggle-menu-sub.open') ||
      root.querySelector('.banner-menu-container')
    );
  }

  function warmImage(img) {
    if (!img) return;
    var probe = new Image();
    var srcset = img.getAttribute('srcset');
    var sizes = img.getAttribute('sizes');
    var src = img.getAttribute('src');
    if (srcset) probe.srcset = srcset;
    if (sizes) probe.sizes = sizes;
    if (src) probe.src = src;
  }

  function afterMegaInsert(li, slot) {
    runScripts(slot);
    li.setAttribute('data-amc-mega-ready', '1');
    function finish() {
      alpineInit(slot);
      var store = window.Alpine && Alpine.store && Alpine.store('xHeaderMenu');
      if (store && typeof store.initToggleMenuHeight === 'function') {
        store.initToggleMenuHeight(li);
      }
      if (store && typeof store.selectItem === 'function') {
        if (li.matches(':hover') || li.classList.contains('is-focus')) {
          store.selectItem(li);
        }
      }
      var first = firstOpenScope(slot);
      if (first) first.querySelectorAll('img').forEach(warmImage);
      bindFindMegaOverflow(slot.querySelector('[data-amc-find-mega]'));
    }
    if (window.Alpine) {
      finish();
      return;
    }
    document.addEventListener('alpine:init', finish, { once: true });
  }

  function hydrate(li) {
    if (!li || li.getAttribute('data-amc-mega-ready') === '1') {
      return Promise.resolve();
    }
    var slot = li.querySelector('[data-amc-mega-slot]');
    if (!slot) {
      li.setAttribute('data-amc-mega-ready', '1');
      return Promise.resolve();
    }

    var src = slot.getAttribute('data-amc-nav-src');
    var tpl = slot.querySelector('template[data-amc-mega-src]');

    if (src) {
      return fetchHtml(src)
        .then(function (html) {
          var panel = parseSelector(html, '[data-amc-nav-panel]');
          var mount = slot.querySelector('[id^="menu-"]') || slot;
          if (panel) adopt(panel, mount);
          afterMegaInsert(li, slot);
        })
        .catch(function () {
          li.removeAttribute('data-amc-mega-ready');
        });
    }

    if (!tpl) {
      li.setAttribute('data-amc-mega-ready', '1');
      return Promise.resolve();
    }

    var first = firstOpenScope(tpl.content);
    if (first) first.querySelectorAll('img').forEach(warmImage);
    slot.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    afterMegaInsert(li, slot);
    return Promise.resolve();
  }

  function findNavMount(id) {
    var live = document.getElementById(id);
    if (live) return live;
    var found = null;
    document.querySelectorAll('template').forEach(function (tpl) {
      if (found || !tpl.content) return;
      found = tpl.content.getElementById(id);
    });
    return found;
  }

  function loadNavRoot(root, attempt) {
    attempt = attempt || 0;
    if (typeof root === 'string') {
      var id = root;
      var mount = findNavMount(id);
      if (!mount) {
        if (attempt > 20) return Promise.resolve();
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(loadNavRoot(id, attempt + 1));
          }, 50);
        });
      }
      root = mount;
    }
    if (!root || root.getAttribute('data-amc-nav-ready') === '1') {
      return Promise.resolve();
    }
    var url = root.getAttribute('data-amc-nav-src');
    if (!url) {
      root.setAttribute('data-amc-nav-ready', '1');
      return Promise.resolve();
    }
    if (root.getAttribute('data-amc-nav-loading') === '1') {
      if (inflight[url] || cache[url]) {
        return (inflight[url] || Promise.resolve(cache[url])).then(function () {
          if (root.getAttribute('data-amc-nav-ready') === '1') return;
          return loadNavRoot(root);
        });
      }
      root.removeAttribute('data-amc-nav-loading');
    }
    root.setAttribute('data-amc-nav-loading', '1');
    return fetchHtml(url)
      .then(function (html) {
        var live = root.id ? document.getElementById(root.id) : null;
        if (live) root = live;
        if (root.getAttribute('data-amc-nav-ready') === '1' && !root.querySelector('[data-amc-nav-shell]')) {
          return;
        }
        var extracted =
          parseSelector(html, '[data-amc-nav-body]') ||
          parseSelector(html, '#menu-navigation');
        var target = root.querySelector('[data-amc-nav-body]') || root;
        if (extracted) adopt(extracted, target);
        root.setAttribute('data-amc-nav-ready', '1');
        root.removeAttribute('data-amc-nav-loading');
        try {
          runScripts(target);
        } catch (e) {}
        if (document.documentElement.contains(target)) {
          try {
            alpineInit(target);
          } catch (e) {}
        }
      })
      .catch(function () {
        root.removeAttribute('data-amc-nav-loading');
      });
  }

  function fromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var li = target.closest('li.has-dropdown[data-amc-mega-lazy]');
    if (li) hydrate(li);
  }

  function onHeaderIntent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('#sticky-header, #x-header-container')) prefetchKind('mega');
  }

  function eachNavSrc(cb) {
    document.querySelectorAll('[data-amc-nav-src]').forEach(cb);
    document.querySelectorAll('template').forEach(function (tpl) {
      if (!tpl.content) return;
      tpl.content.querySelectorAll('[data-amc-nav-src]').forEach(cb);
    });
  }

  function prefetchKind(kind) {
    eachNavSrc(function (el) {
      if (el.getAttribute('data-amc-nav-kind') !== kind) return;
      var url = el.getAttribute('data-amc-nav-src');
      if (url) fetchHtml(url).catch(function () {});
    });
  }

  function prefetchAfterLcp() {
    if (warmed) return;
    warmed = true;
    if (desktopMega.matches) {
      prefetchKind('mega');
      return;
    }
    prefetchKind('mobile');
    loadNavRoot('mobile-navigation');
  }

  document.addEventListener('mouseover', fromEvent, true);
  document.addEventListener('focusin', fromEvent, true);
  document.addEventListener('touchstart', fromEvent, { capture: true, passive: true });
  document.addEventListener('click', fromEvent, true);
  document.addEventListener('pointerenter', onHeaderIntent, true);

  function onHamburgerIntent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('#amc-header-menu-toggle, [data-amc-header-menu-toggle]')) {
      loadNavRoot('mobile-navigation');
    }
  }

  document.addEventListener('pointerdown', onHamburgerIntent, true);
  document.addEventListener('touchstart', onHamburgerIntent, { capture: true, passive: true });
  document.addEventListener(
    'click',
    function (event) {
      onHamburgerIntent(event);
    },
    true
  );

  function patchStore(name, rootId) {
    var store = Alpine.store(name);
    if (!store || store._amcNavPatched) return;
    store._amcNavPatched = true;
    var orig = store.open.bind(store);
    store.open = function () {
      loadNavRoot(rootId);
      orig.apply(this, arguments);
    };
  }

  document.addEventListener('alpine:init', function () {
    queueMicrotask(function () {
      patchStore('xMobileNav', 'mobile-navigation');
      patchStore('xMenuDrawer', 'menu-drawer');
    });
  });

  function markScrollerOverflow(host, scroller) {
    if (!host) return;
    if (!scroller) {
      host.classList.remove('is-overflow-top', 'is-overflow-bottom');
      return;
    }
    var max = scroller.scrollHeight - scroller.clientHeight;
    host.classList.toggle('is-overflow-top', scroller.scrollTop > 4);
    host.classList.toggle('is-overflow-bottom', max > 8 && scroller.scrollTop < max - 4);
  }

  function syncFindMegaOverflow(mega) {
    if (!mega) return;
    markScrollerOverflow(mega.querySelector('.amc-find-mega__rail'), mega.querySelector('.amc-find-mega__states'));
    markScrollerOverflow(
      mega.querySelector('.amc-find-mega__stage'),
      mega.querySelector('.amc-find-mega__panel.is-active')
    );
  }

  function bindFindMegaOverflow(mega) {
    if (!mega) return;
    if (mega.getAttribute('data-amc-overflow-bound') !== '1') {
      mega.setAttribute('data-amc-overflow-bound', '1');
      var sync = function () {
        syncFindMegaOverflow(mega);
      };
      var states = mega.querySelector('.amc-find-mega__states');
      if (states) states.addEventListener('scroll', sync, { passive: true });
      mega.querySelectorAll('.amc-find-mega__panel').forEach(function (panel) {
        panel.addEventListener('scroll', sync, { passive: true });
      });
      var more = mega.querySelector('.amc-find-mega__more');
      if (more && states) {
        more.addEventListener('click', function () {
          states.scrollBy({ top: Math.round(states.clientHeight * 0.6), behavior: 'smooth' });
        });
      }
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(sync);
        ro.observe(mega);
        if (states) ro.observe(states);
      }
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        syncFindMegaOverflow(mega);
      });
    });
  }

  function activateFindMegaState(mega, item) {
    var key = item.getAttribute('data-amc-find-state');
    mega.querySelectorAll('[data-amc-find-state]').forEach(function (el) {
      el.classList.toggle('is-active', el === item);
    });
    mega.querySelectorAll('[data-amc-find-panel]').forEach(function (el) {
      var on = el.getAttribute('data-amc-find-panel') === key;
      el.classList.toggle('is-active', on);
      if (on) el.querySelectorAll('img').forEach(warmImage);
    });
    bindFindMegaOverflow(mega);
  }

  document.addEventListener('pointerover', function (event) {
    var item = event.target.closest('[data-amc-find-state]');
    if (!item) return;
    var mega = item.closest('[data-amc-find-mega]');
    if (!mega) return;
    activateFindMegaState(mega, item);
  });

  document.addEventListener(
    'wheel',
    function (event) {
      var mega = event.target.closest('[data-amc-find-mega]');
      if (!mega) return;
      var scroller = event.target.closest('.amc-find-mega__states, .amc-find-mega__panel');
      var overHint = !scroller && event.target.closest('.amc-find-mega__more, .amc-find-mega__rail');
      if (overHint) scroller = mega.querySelector('.amc-find-mega__states');
      if (!scroller || !mega.contains(scroller)) {
        event.preventDefault();
        return;
      }
      if (overHint) {
        scroller.scrollTop += event.deltaY;
        event.preventDefault();
        return;
      }
      var atTop = scroller.scrollTop <= 0 && event.deltaY < 0;
      var atBottom =
        scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1 && event.deltaY > 0;
      if (atTop || atBottom) event.preventDefault();
    },
    { passive: false }
  );

  if ('PerformanceObserver' in window) {
    try {
      var po = new PerformanceObserver(function (list) {
        if (list.getEntries().length) prefetchAfterLcp();
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) {
      /* older Safari */
    }
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetchAfterLcp, { timeout: 4000 });
  } else {
    window.addEventListener('load', function () {
      setTimeout(prefetchAfterLcp, 1200);
    });
  }

  window.amcHydrateMega = hydrate;
  window.amcLoadNavRoot = loadNavRoot;
})();
